import { useState } from 'react';
import styles from 'styles/modules/Register.module.scss';
import SEO from 'next-seo.config';
import { NextSeo } from 'next-seo';
import RegisterJournalist from 'components/Register/RegisterJournalist';

export default function Register() {
    const [formData, setFormData] = useState({
        type: 'journalist',
        user: {
            email: null,
            password: null,
            confirmPassword: null,
        },
        registered: false,
    });

    let stepToShow;

    if (formData.type && !formData.user.email) {
        stepToShow = (
            <RegisterJournalist
                state={{
                    setFormData,
                    formData,
                }}
            />
        );
    }

    return (
        <>
            <NextSeo {...SEO} titleTemplate={`Register | %s`} />
            <div className={['container', styles.pageRegister].join(' ')}>
                {stepToShow}
            </div>
        </>
    );
}
